import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IDeclinedMeetingRequestClient,
} from 'interfaceAdapter/gatewaySchemas/IDeclinedMeetingRequestClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/company/decline/request_meeting`;

export class DeclinedMeetingRequestClient implements IDeclinedMeetingRequestClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, match_id, reason } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-C': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({ match_id: match_id, reason: reason });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
